module.exports = __webpack_public_path__ + "media/locales/_it-cc79b186.png";